import React from 'react';
import NavDropdownHover from './NavDropdownHover';
import { NavItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { changeLanguage } from './actions';
import { connect } from 'react-redux';

const isMobileMenu = window.innerWidth < 768;
const LanguageMenu = ({ languages, onSelectLanguage }) => {
    const activeLanguage = languages.find(l => l.state === 'active');

    const renderTitle = 
        <span>
            <img src={activeLanguage ? require(`../../theme/images/lang/${activeLanguage.image}`) : ''} /> 
        </span>;

    return <NavDropdownHover id='languageMenu' key='languageMenu' openOnHover={!isMobileMenu} 
        title={activeLanguage && renderTitle} >
        {languages.map((language) =>
            <NavItem key={language.id} onClick={() => onSelectLanguage(language.culture)} >
                <img src={require(`../../theme/images/lang/${language.image}`)} alt={language.image} />
                <span className={activeLanguage && language.id !== activeLanguage.id ? 'text-muted' : ''}>{language.name}</span>
            </NavItem>
        )}
    </NavDropdownHover>;
};

const mapStateToProps = (state) => ({
    languages: state.configuration.language
});

const mapDispatchToProps = {
    onSelectLanguage: language => changeLanguage(language)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LanguageMenu));